import { render, staticRenderFns } from "./CoverCheck.vue?vue&type=template&id=73ed2ec8"
import script from "./CoverCheck.vue?vue&type=script&lang=js"
export * from "./CoverCheck.vue?vue&type=script&lang=js"
import style0 from "./CoverCheck.vue?vue&type=style&index=0&id=73ed2ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports